import React from 'react';
import { IoMdClose } from 'react-icons/io';

const Modal = ({ title, isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm`}
    >
      {/* eslint-disable-next-line */}
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div className="bg-2 text-p-text relative z-10 flex h-[90%] w-[90%] max-w-3xl flex-col rounded-lg border border-zinc-700">
        {title && (
          <div className="br-1 flex justify-between gap-3 border-b px-3 py-5">
            <h1 className="px-3 py-1.5 text-xl font-bold text-zinc-200">
              {title}
            </h1>
            <div>
              <button
                onClick={onClose}
                className="bg-1 rounded-lg p-1.5 text-zinc-300 transition-all duration-200"
              >
                <IoMdClose />
              </button>
            </div>
          </div>
        )}
        {!title && (
          <button
            onClick={onClose}
            className="bg-1 absolute right-5 top-5 rounded-lg p-1.5 text-zinc-300 transition-all duration-200"
          >
            <IoMdClose />
          </button>
        )}
        <div className="flex-grow overflow-y-auto p-4">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
